import './login.css';

import { IonCol, IonContent, IonGrid, IonPage, IonRow } from '@ionic/react';
import { ReactElement } from 'react';
import { Login } from '../../components/login/login';
import { LoginWelcome } from '../../components/login/login-welcome';

const LoginPage = (): ReactElement => {
  return (
    <IonPage>
      <IonContent>
        <IonGrid className="login-page-container ion-no-padding">
          <IonRow>
            <IonCol sizeMd="6" sizeXs="12" pushMd="6" pushXs="0">
              <Login />
            </IonCol>
            <IonCol sizeMd="6" sizeXs="12" pullMd="6" pullXs="0">
              <LoginWelcome />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export { LoginPage };
